import { Locale } from '@headless-workspace/config';
import { ConfigByKeyRepository, Result, ResultEmpty, ResultSuccess } from '@headless-workspace/core-domain';
import { DecoderHelpers } from '@headless-workspace/utils';
import { z } from 'zod';

export const BOOKING_CONFIG_KEY = 'defaultBooxiApiKey';

export interface BookingConfigRepositorySpec {
    fetchBookingConfiguration(locale: Locale): Promise<Result<string>>;
}

export class BookingConfigRepository extends ConfigByKeyRepository implements BookingConfigRepositorySpec {
    async fetchBookingConfiguration(locale: Locale): Promise<Result<string>> {
        const bookingConfigResult = await this.getConfigByKey(BOOKING_CONFIG_KEY, { locale }, (value) =>
            z.record(z.string()).parse(value),
        );

        if (bookingConfigResult.type !== 'success') {
            return ResultEmpty();
        }

        const bookingValue = DecoderHelpers.parseByLocaleCountry(bookingConfigResult.data, locale);

        if (bookingValue === undefined) {
            return ResultEmpty();
        }

        return ResultSuccess(bookingValue);
    }
}
